import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Box } from 'reflexbox';
import styled from 'styled-components';

interface IElementProps {
	bordered?: boolean;
	grow?: boolean;
	backgroundColor?: string;
}

interface ILinkProps {
	to: string;
	target?: string;
}

const Element = styled.div<IElementProps>`
	background-color: ${(props) =>
		props.backgroundColor
			? props.theme.colors[props.backgroundColor]
			: props.theme.colors.lightBlueLight};
	border: ${(props) => (props.bordered ? `1px solid ${props.theme.colors.primary}` : 'none')};
	border-radius: 6px;
	width: 100%;
	@media print {
		padding: 15px 15px;
		background-color: white;
		border: 3px solid ${(props) => props.theme.colors.lightBlueLight};
	}
`;

const LinkElement = styled(Link)`
	& > div {
		transition:
			300ms transform ease-out,
			300ms box-shadow ease-out;
	}

	&:hover > div {
		transform: translateY(-3px);
		box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.1);
	}

	&:active > div {
		transform: none;
	}
`;

interface IProps extends IElementProps {
	children: ReactNode;
	header?: ReactNode;
	padding?: PlainHorizontalCardPadding;
	my?: number;
	onClick?: () => void;
}

export enum PlainHorizontalCardPadding {
	None,
	Small,
	Large,
}

const paddings: Record<PlainHorizontalCardPadding, Array<number>> = {
	[PlainHorizontalCardPadding.None]: [0],
	[PlainHorizontalCardPadding.Small]: [2, 2, 3],
	[PlainHorizontalCardPadding.Large]: [2, 3, 4],
};

const PlainHorizontalCard = ({
	children,
	header,
	padding = PlainHorizontalCardPadding.Small,
	my,
	bordered,
	backgroundColor,
	grow,
	onClick,
}: IProps) => (
	<Element
		bordered={bordered}
		backgroundColor={backgroundColor}
		style={grow ? { height: '100%' } : {}}
		onClick={onClick}
	>
		<Box p={paddings[padding]} my={my}>
			{header}
			{children}
		</Box>
	</Element>
);

export const PlainHorizontalCardLink = ({
	to,
	target = '_self',
	grow,
	...props
}: IProps & ILinkProps) => (
	<LinkElement target={target} to={to} style={grow ? { display: 'block', height: '100%' } : {}}>
		<PlainHorizontalCard {...props} grow={grow} />
	</LinkElement>
);

export default PlainHorizontalCard;
